import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { ArrayNotEmpty, IsNumber, IsOptional, Min } from 'class-validator';
import { Appearance } from '../transcript';
import { ModifyLineItemProperties } from './ModifyLineItemProperties';
/**
 * A list of transcript line item properties that are allowed to be modified
 */
export class ModifyTranscriptLineItemProperties extends ModifyLineItemProperties {
}
__decorate([
    IsOptional(),
    ArrayNotEmpty(),
    __metadata("design:type", Object)
], ModifyTranscriptLineItemProperties.prototype, "hearingPortions", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    Min(0),
    __metadata("design:type", Object)
], ModifyTranscriptLineItemProperties.prototype, "paperCopies", void 0);
__decorate([
    Type(() => Appearance),
    __metadata("design:type", Object)
], ModifyTranscriptLineItemProperties.prototype, "appearances", void 0);
